import { render } from "./App.vue?vue&type=template&id=eda87d86"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=eda87d86&lang=css"

import exportComponent from "C:\\NFT4ART\\nft4art\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__